import { Trophy, Radio, ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";

const CLASSIFICA_URL = "https://www.tuttocampo.it/Lombardia/SecondaCategoria/GironeOMilano/Classifica";
const RISULTATI_URL = "https://www.tuttocampo.it/Lombardia/SecondaCategoria/GironeOMilano/Risultati";
const CSI_URL = "https://www.csi.milano.it/albo/risultati-calendario-classifiche-squadre.html?q=cla";

const LINKS = [
  {
    icon: Trophy,
    title: "Classifica Live",
    desc: "Il girone in tempo reale: punti, vittorie e posizione dell'Artemide aggiornati dopo ogni giornata.",
    url: CLASSIFICA_URL,
    cta: "Apri la Classifica",
    testid: "classifica-link-card",
  },
  {
    icon: Radio,
    title: "Risultati Live",
    desc: "Segui la partita della Prima Squadra minuto per minuto: gol, marcatori e risultati in diretta.",
    url: RISULTATI_URL,
    cta: "Segui il Live",
    testid: "risultati-link-card",
  },
];

const LINKS_CSI = [
  {
    icon: Trophy,
    title: "Classifica CSI",
    desc: "La classifica dell'Open B Girone B aggiornata dopo ogni giornata sul portale CSI Milano.",
    url: CSI_URL,
    cta: "Apri la Classifica",
    testid: "classifica-csi-link-card",
  },
  {
    icon: Radio,
    title: "Risultati CSI",
    desc: "Risultati e referti delle partite della Seconda Squadra sul portale ufficiale CSI Milano.",
    url: CSI_URL,
    cta: "Vedi i Risultati",
    testid: "risultati-csi-link-card",
  },
];

export default function Classifiche() {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 py-20" data-testid="classifiche-page">
      <h1 className="font-display font-black uppercase text-6xl sm:text-8xl lg:text-9xl text-white leading-[0.85] tracking-[0.02em] mb-16" data-testid="classifiche-title">
        Classifiche <span className="text-gold">e Live</span>
      </h1>

      <Reveal data-testid="classifiche-figc">
        <div className="flex items-center gap-4 mb-8">
          <span className="h-1 w-12 bg-gold" />
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">
            Prima Squadra <span className="text-gold">FIGC</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-20">
          {LINKS.map((l) => (
            <a
              key={l.title}
              href={l.url}
              target="_blank"
              rel="noreferrer"
              data-testid={l.testid}
              className="group grey-fade border border-line border-l-4 border-l-gold p-10 hover:border-gold transition-colors"
            >
              <l.icon className="text-gold mb-6" size={36} />
              <h3 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">{l.title}</h3>
              <p className="text-zinc-400 mt-4 max-w-sm">{l.desc}</p>
              <p className="mt-8 flex items-center gap-2 text-gold font-display uppercase tracking-wider font-bold text-lg">
                {l.cta} <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </p>
            </a>
          ))}
        </div>
      </Reveal>

      <Reveal data-testid="classifiche-csi">
        <div className="flex items-center gap-4 mb-8">
          <span className="h-1 w-12 bg-gold" />
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">
            Seconda Squadra <span className="text-gold">CSI</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-testid="classifiche-csi-links">
          {LINKS_CSI.map((l) => (
            <a
              key={l.title}
              href={l.url}
              target="_blank"
              rel="noreferrer"
              data-testid={l.testid}
              className="group grey-fade border border-line border-l-4 border-l-gold p-10 hover:border-gold transition-colors"
            >
              <l.icon className="text-gold mb-6" size={36} />
              <h3 className="font-display font-black uppercase text-4xl sm:text-5xl text-white leading-none">{l.title}</h3>
              <p className="text-zinc-400 mt-4 max-w-sm">{l.desc}</p>
              <p className="mt-8 flex items-center gap-2 text-gold font-display uppercase tracking-wider font-bold text-lg">
                {l.cta} <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </p>
            </a>
          ))}
        </div>
      </Reveal>
    </main>
  );
}
